import swal from "sweetalert";
import { changeRequestItem } from '../dataApi'

export const processChangeItem = async (idItem, changeRequestItemDto) => {
    const setFinal = await swal({text: "Se procede a Modificar el producto, ¿Desea continuar?", icon: "info", buttons: ["Cancelar", "Continuar"],})
    if(!setFinal) return false
    
    const res = (await changeRequestItem(idItem, changeRequestItemDto)).data;
    
    if(!res.success) {
        swal("Tenemos problemas", res.message, "error")
        return false
    }
    
    swal("Todo bien", res.message, "success")
    return true
}